// extracted by mini-css-extract-plugin
export default {"deleteBtn":"AddDevice_deleteBtn__1G06S","errorMessage":"AddDevice_errorMessage__TgHz2","costNote":"AddDevice_costNote__ZIy8F","overfowX":"AddDevice_overfowX__eKHba"};